import React, { useState } from "react";
import axios from "axios";
import ClientNavbar from "../layout/ClientNavbar";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

export default function IncomeTaxDetails() {
  const allData = [
    { id: "COLA250925", fileName: "Home Loan", date: "24 Sep, 2025" },
    { id: "COLA250924", fileName: "CC/OD - Secured", date: "24 Sep, 2025" },
    { id: "COLA250923", fileName: "Personal Loan", date: "20 Sep, 2025" },
    { id: "COLA250922", fileName: "Car Loan", date: "18 Sep, 2025" },
    { id: "COLA250921", fileName: "Business Loan", date: "15 Sep, 2025" },
    { id: "COLA250920", fileName: "Education Loan", date: "12 Sep, 2025" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(2);
  const totalPages = Math.ceil(allData.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentData = allData.slice(indexOfFirst, indexOfLast);

  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // ✅ Modal State
  const [showModal, setShowModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // file upload state
  const [fileDoc, setFileDoc] = useState(null);
  const [fileError, setFileError] = useState("");
  const [uploading, setUploading] = useState(false);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
  const ALLOWED_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/jpeg",
    "image/png",
  ];

  const handleFileChange = (e) => {
    setFileError("");
    const f = e.target.files[0];
    if (!f) {
      setFileDoc(null);
      return;
    }

    if (!ALLOWED_TYPES.includes(f.type)) {
      setFileError("Invalid file type. Allowed: PDF, DOC, DOCX, JPG, PNG.");
      setFileDoc(null);
      return;
    }

    if (f.size > MAX_FILE_SIZE) {
      setFileError("File is too large. Maximum 5 MB allowed.");
      setFileDoc(null);
      return;
    }

    setFileDoc(f);
  };

  const clearFile = () => {
    setFileDoc(null);
    setFileError("");
  };

  // handle submit -> send FormData via axios
  const handleSubmit = async (e) => {
    e.preventDefault();

    // basic validation
    if (!username || !password) {
      alert("Please enter username and password.");
      return;
    }

    // optionally require a file (if necessary)
    // if (!fileDoc) { alert("Please upload a document."); return; }

    if (fileError) {
      alert(fileError);
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("username", username);
      formData.append("password", password);
      if (fileDoc) {
        formData.append("document", fileDoc); // backend should read key 'document'
      }

      // Change this URL to your actual backend endpoint
      const API_URL = `${process.env.REACT_APP_BACKEND_BASE_URL || ""}/api/income-tax/upload`;

      const resp = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          // optional: you can compute percentage and show progress if you add UI
          // const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      });

      // handle success
      // adjust logic depending on your API response structure
      if (resp?.status === 200 || resp?.status === 201) {
        alert("Uploaded successfully.");
        // reset modal fields
        setUsername("");
        setPassword("");
        setFileDoc(null);
        setFileError("");
        setShowModal(false);
      } else {
        alert("Upload failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while uploading. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>

     

        <div className="card shadow-sm p-4 mb-4">
          
             <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2">
              <h3 className="text-primary mb-2">Income Tax Details</h3>
              <button className="btn btn-primary" onClick={() => setShowModal(true)}>
                Get Income Tax Report
              </button>
            </div>
               <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                   
                <li className="breadcrumb-item active" aria-current="page">
                Income Tax Details
                </li>
              </ol>
            </nav>
            {/* Header + Button */}
         
            </div>
            <div className="card shadow-sm p-4 mb-4">

            {/* Table */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead style={{ backgroundColor: "#FFE6DC" }}>
                  <tr>
                    <th>Sr.No.</th>
                    <th>File Name</th>
                    <th>Fetched Date & Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((item, index) => (
                    <tr key={item.id}>
                      <td className="text-primary fw-semibold">{item.id}</td>
                      <td>{item.fileName}</td>
                      <td>{item.date}</td>
                      <td>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#ff6600",
                            color: "#fff",
                            fontSize: "0.9rem",
                            padding: "8px 16px",
                          }}
                        >
                          Pending
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center mt-4">
              <div>
                <select
                  className="form-select d-inline-block"
                  style={{ width: "80px" }}
                  value={rowsPerPage}
                  onChange={handleRowsChange}
                >
                  <option value={2}>2</option>
                  <option value={4}>4</option>
                  <option value={6}>6</option>
                </select>
              </div>

              <div className="d-flex align-items-center">
                <button className="btn btn-primary me-2" onClick={handlePrev} disabled={currentPage === 1}>
                  &laquo;
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  style={{ borderRadius: "50%", width: "36px", height: "36px" }}
                >
                  {currentPage}
                </button>
                <button className="btn btn-primary ms-2" onClick={handleNext} disabled={currentPage === totalPages}>
                  &raquo;
                </button>
              </div>

              <div>
                <span>
                  {indexOfFirst + 1} - {Math.min(indexOfLast, allData.length)} of {allData.length}
                </span>
              </div>
            </div>

            {/* Back Button */}
            <div className="mt-4">
              <Link to="/clientloan" className="text-decoration-none text-dark">
                <button className="btn btn-primary px-4">Back</button>
              </Link>
            </div>
          </div>
        </div>

      {/* ✅ Popup Modal */}
      {showModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
        >
          <div className="bg-white p-4 rounded shadow" style={{ width: "420px", maxWidth: "92%" }}>
            <h5 className="mb-3 text-center">Income Tax Details</h5>

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-3">
                <label className="form-label fw-semibold">User Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter PAN password"
                  required
                />
                <small className="text-danger">Please enter PAN password</small>
              </div>

              {/* File upload section */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Upload Document</label>

                <div className="d-flex gap-2 align-items-center">
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={handleFileChange}
                    className="form-control form-control-sm"
                    style={{ maxWidth: 250 }}
                  />

                  {fileDoc ? (
                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                      <small className="text-muted">{fileDoc.name}</small>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={clearFile}>
                        Remove
                      </button>
                    </div>
                  ) : (
                    <small className="text-muted">Allowed: PDF, DOC, DOCX, JPG, PNG (max 5MB)</small>
                  )}
                </div>

                {fileError && <div className="text-danger mt-1" style={{ fontSize: 13 }}>{fileError}</div>}
              </div>

              <div className="d-flex justify-content-between mt-3">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setShowModal(false);
                    // reset modal states when closed
                    setUsername("");
                    setPassword("");
                    setFileDoc(null);
                    setFileError("");
                  }}
                >
                  Back
                </button>

                <button type="submit" className="btn btn-primary" disabled={uploading || !!fileError}>
                  {uploading ? "Uploading..." : "Get Details"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
  
